module.exports = __webpack_public_path__ + "a589b00a2f289e0029c609a6e96f452e.svg";